import axios from "axios";
import * as actionType from "../../constant/actionType";

export const UpdateProviderRegisTempData = (ApiData) => async (dispatch) => {
  try {
    let Data = ApiData;

    // Check if registrationType is 'forYourself' and client_fa_id is null, then remove client_fa_id
    if (Data?.registrationType === "forYourself" && Data?.client_fa_id === null) {
      delete Data.client_fa_id;
    }

    // Remove unnecessary fields from ApiData
    delete ApiData.created_by;
    delete ApiData.updated_by;
    delete ApiData.deleted_by;
    delete ApiData.deleted_date;
    delete ApiData.created_date;
    delete ApiData.updated_date;
    delete ApiData.temp_msa_doc;
    delete ApiData.temp_engagement_doc;

    let formdata = new FormData();

    // Loop through the data and append to formdata
    for (let key in Data) {
      if (key == "provider_regist_data") {
        // Create a new object to store the formatted data
        let providerData = {};

        for (let innerData in Data[key]) {
          if (innerData == "address_data" || innerData == "individual_data") {
            providerData[innerData] = JSON.stringify(Data[key][innerData]);
          } else {
            providerData[innerData] = Data[key][innerData];
          }
        }

        // Append the entire provider_regist_data object as a JSON string
        formdata.append(key, JSON.stringify(providerData));
      } else {
        // Check if user_id or invite_provider_id are null, and append empty string if so
        if (key == "user_id" || key == "invite_provider_id") {
          formdata.append(key, Data[key] == null ? "" : Data[key]);
        } else {
          formdata.append(key, Data[key]);
        }
      }
    }

    const response = await axios({
      method: "put",
      data: formdata,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/UpdateProviderRegisTempData`,
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};
